// ** URL API FOR PRODUCTION LIVE **

export const environment = {
  production: true,
  apiURL: "https://web.chatfoto.id/",
  apiFilesURL: "https://files.chatfoto.id/",
  apiURLWa: "https://api.chatfoto.id/whatsapp/",
  apiURLsicepat: "https://dmmspot.id/api_third_party/sicepat/request/",
  apiURLpayment: 'https://dmmspot.id/api-payment/public/',
  urlIndex: 'https://chatfoto.id',
  apiFrame: "https://dmmspot.id/api-payment/public/",
  
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebase: {
    apiKey: "AIzaSyCadMIxT9RM3gWSTD5Xp80ufgloM-2P2oE",
    authDomain: "easy-photo-fujifilm.firebaseapp.com",
    projectId: "easy-photo-fujifilm",
    storageBucket: "easy-photo-fujifilm.appspot.com",
    messagingSenderId: "155464318501",
    appId: "1:155464318501:web:3a924ffd3f96b5f82709cc",
    measurementId: "G-F3711N0D71",
    vapidKey: "BDexmkmUJxKnjetCPln8kTiKw1_SAEjBZ_rFOVqINV_ja8kDhDGKLYjv0Pfc3eTQybU-NCDlMLE01C_nH0S-GUg"
  },
};
